/* Arjit4Amply: Science page ingredient-library filter, ported from the
   reference's science-page.js - each button shows only the cards whose
   data-science-products list includes its product (or all of them), and
   the live count updates for screen readers via its role="status". */
(function () {
  var filters = Array.prototype.slice.call(document.querySelectorAll('[data-science-filter]'));
  var cards = document.querySelectorAll('[data-science-products]');
  var count = document.querySelector('[data-science-count]');
  if (!filters.length || !count) return;

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      var selected = button.dataset.scienceFilter;
      var visible = 0;

      filters.forEach(function (other) {
        other.setAttribute('aria-pressed', String(other === button));
      });

      Array.prototype.forEach.call(cards, function (card) {
        card.hidden = selected !== 'all' && card.dataset.scienceProducts.split(' ').indexOf(selected) === -1;
        if (!card.hidden) visible++;
      });

      count.textContent = visible + ' ingredient' + (visible === 1 ? '' : 's');
    });
  });
})();
